import { Component, _decorator } from 'cc';
import Lobby from '../../../System/Lobby';
import SceneManager from '../../../../common/scripts/SceneManager';
import MultiThemeNode from '../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeNode';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import { SceneName } from '../../Data/Config/SceneNodeName';

const { ccclass, requireComponent } = _decorator;

@ccclass('PopupPositionAdjustor')
@requireComponent(Page)
export default class PopupPositionAdjustor extends Component {
    private _page: Page = null;
    private _viewMultiThemeNode: MultiThemeNode = null;

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    private get viewMultiThemeNode() {
        if (!this._viewMultiThemeNode) {
            this._viewMultiThemeNode = this.page.view.getComponent(MultiThemeNode);
        }
        return this._viewMultiThemeNode;
    }

    protected onLoad() {
        this.page.on(Page.EVENT_TYPE.OPEN_START, this._updatePosition, this);
        Lobby.scene?.on(SceneManager.EVENT_TYPE.AFTER_SCENE_CHANGED, this._updatePosition, this);
    }

    private _updatePosition() {
        let theme = 0;
        if (Lobby.scene) {
            if (Lobby.scene.currentSceneName !== SceneName.OuterLobby && Lobby.scene.currentSceneName !== SceneName.Lobby) {
                theme = 1;
            }
            // Check if there is any other popup that is visible or active
            const { allCrossSceneNodes: allCrossSceneNode } = Lobby.scene;
            for (let i = 0; i < allCrossSceneNode.length; i++) {
                const crossSceneNode = allCrossSceneNode[i];
                if (crossSceneNode === this.node) {
                    continue;
                }
                const page = crossSceneNode.getComponent(Page);
                if (page) {
                    if (page.isVisible) {
                        theme = 0;
                        break;
                    }
                } else if (crossSceneNode.active) {
                    theme = 0;
                    break;
                }
            }
        }
        this.viewMultiThemeNode.theme = theme;
    }
}
